module.exports = __webpack_public_path__ + "img/step1.58ef1457.svg";